export default __webpack_public_path__ + "static/media/01 Marketing - Floor Plan by Type 5.01960815.jpeg";